import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'

interface AuthConfirmLogoutProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export const AuthConfirmLogout: React.FC<AuthConfirmLogoutProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Sign out</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Do you want to continue signing out?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} autoFocus>
          Sign out
        </Button>
      </DialogActions>
    </Dialog>
  )
}
